import createAnimationWrapper from "./createAnimationWrapper";

const anim = (strength) => ({
  "0%, 50%, 100%": { transform: `translate(0,0)` },
  "25%": { transform: `translate(-${strength * 10}px,-${strength * 4}px)` },
  "55%": { transform: `translate( ${strength * 10}px,${strength * 7}px)` },
  "75%": { transform: `translate(-${strength * 7}px,${strength * 4}px)` }
});

const WiggleBase = createAnimationWrapper(anim, {
  duration: "0.3s",
  loop: true
});


const Wiggle = ({strength=1, ...props}) => <WiggleBase animation={anim(strength)} {...props} />;

export default Wiggle;
